import { RFIResponseDisciplines } from '../../../cimsPage/instances/rfi'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const object = 'Response Discipline'
const page = RFIResponseDisciplines

const responseDiscipline = CreateViewEditSoftRemoveRestore({
  page,
  object,
  create: 'fc524f86-718b-4c5c-903f-d2a09f3155f8',
  view: '1cc64e6f-3965-4735-80d9-04e75deb5fdf',
  edit: '158ecfd2-388e-4530-9222-5bbae962176f',
  removeRestore: '9eb26418-0910-455f-a52c-8c10172f0540',
})

export const CreateRFIResponseDiscipline = responseDiscipline.Create
export const ViewRFIResponseDiscipline = responseDiscipline.View
export const EditRFIResponseDiscipline = responseDiscipline.Edit
export const RemoveRestoreRFIResponseDiscipline =
  responseDiscipline.RemoveRestore

export type RFIResponseDisciplinePermission =
  | typeof CreateRFIResponseDiscipline
  | typeof ViewRFIResponseDiscipline
  | typeof EditRFIResponseDiscipline
  | typeof RemoveRestoreRFIResponseDiscipline
